module.exports = __webpack_public_path__ + "static/media/logo_color.281a8a62.svg";